// extracted by mini-css-extract-plugin
export default {"containerMessages":"style_containerMessages__4HwZF"};